export function mapCreateQuestionSetToApiRequest(data) {
    var _a;
    return {
        component_question_set: {
            name: data.name,
            description: data.description,
            active: (_a = data.active) !== null && _a !== void 0 ? _a : true
        }
    };
}
export function mapUpdateQuestionSetToApiRequest(data) {
    return {
        component_question_set: {
            name: data.name,
            description: data.description,
            active: data.active
        }
    };
}
export function mapCreateQuestionToApiRequest(data) {
    return {
        question: {
            question_text: data.questionText,
            esp_question_text: data.questionTextEs,
            fr_question_text: data.questionTextFr,
            question_type: data.questionType,
            frequency_type: data.frequencyType,
            section_id: data.sectionId,
            answer_choices: data.answerChoices
        }
    };
}
